import { serializeSuperjson } from '@lib/superjson';
import type {
  CreateSnapQuotePriceBody,
  CreateSnapQuotePriceOutput,
  CreateSnapQuotePriceParams,
} from '@snap-types/actions/create-snap-quote-price';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

type Input = {
  params: CreateSnapQuotePriceParams;
  body: CreateSnapQuotePriceBody;
};

const [createSnapQuotePrice, _] = injectMutation<
  Input,
  CreateSnapQuotePriceOutput
>(`${QUOTE_BUILDER_SLICE_NAME}/createSnapQuotePrice`, ({ params, body }) => ({
  url: buildSnapQuoteUrl(
    params.siteCode,
    params.snapQuoteUuid,
    `quote-lines/${params.snapQuoteLineUuid}/quote-prices`,
  ),
  method: 'POST',
  body: serializeSuperjson(body),
}));

export { createSnapQuotePrice };
